import { useEffect } from 'react'
import { useLocation } from 'wouter'
import { useLingui } from '@lingui/react/macro'

import { showToast, ToastType } from '@/features/toast'
import { useIsPmsConnected } from '../hooks/useIsPmsConnected'
import { appPath } from '@/utils/appPath'

type Props = React.PropsWithChildren<{
  redirect?: string
}>

export default function CheckPms({
  children,
  redirect = `~${appPath('/goodies')}`
}: Props) {
  const { t } = useLingui()
  const isEnabled = !useIsPmsConnected()
  const [, navigate] = useLocation()

  useEffect(() => {
    if (isEnabled || !redirect) return

    showToast({
      id: 'no-permission-redirect',
      type: ToastType.ERROR,
      message: t({
        comment:
          'Toaster error message when a user tries to access a resource that is currently synced with a PMS.',
        message:
          'You currently have a PMS connected, and have to do this action in your PMS backoffice.'
      })
    })

    navigate(redirect)
  }, [isEnabled, redirect, navigate, t])

  return isEnabled ? children : null
}
